<!-- 资金管理-商户列表 -->
<template>
  <div>
    <page
      :url="url"
      :form="form"
      @reset="reset"
      :sort-info="{ prop: 'createTimeL', order: 'descending' }"
    >
      <template slot="tableSearch">
        <el-form-item label="状态">
          <el-select v-model="form.status" placeholder="状态">
            <el-option label="请选择" value=""></el-option>
            <el-option label="处理中" value="00"></el-option>
            <el-option label="提现成功" value="01"></el-option>
            <el-option label="提现失败" value="02"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日期">
          <el-date-picker
            v-model="timeDate"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyyMMdd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          >
          </el-date-picker>
        </el-form-item>
      </template>
      <template slot="tableColumn">
        <el-table-column
          width="250"
          prop="orderId"
          label="订单号2"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="createTimeFormat"
          label="创建时间"
          sortable
          align="center"
        ></el-table-column>

        <el-table-column
          prop="status"
          label="状态"
          width="100px"
          :formatter="$formatter.formatWithdrawStatus"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              size="small"
              :type="
                row.status == '00'
                  ? 'warning'
                  : row.status == '01'
                  ? 'success'
                  : 'danger'
              "
              >{{
                $formatter.formatWithdrawStatus(null, null, row.status, null)
              }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          prop="amount"
          width="200px"
          label="提现金额=币 x 汇率"
          :formatter="$formatter.FenToYuan"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ $formatter.FenToYuan(null, null, row.amount, null) }} =
            {{ row.fromAmount }} x
            {{ row.exchangeRate ? row.exchangeRate : ' ' }}
          </template>
        </el-table-column>

        <el-table-column prop="paymentAccount" label="打款账号" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.paymentAccount">{{ row.paymentAccount }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectAccount"
          label="收款账号"
          align="center"
        ></el-table-column>

        <el-table-column
          width="200"
          prop="remark"
          label="申请备注"
          align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.remark">
              <el-popover
                v-if="row.remark && row.remark.length > 12"
                placement="top-start"
                width="300"
                trigger="hover"
                :content="row.remark"
              >
                <div slot="reference" class="remark">{{ row.remark }}</div>
              </el-popover>
              <div v-else>{{ row.remark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          width="160"
          prop="dealTimeFormat"
          label="处理时间"
          align="center"
        ></el-table-column>

        <el-table-column
          width="200"
          prop="approveRemark"
          label="审批备注"
          align="center"
        >
          <template slot-scope="{ row }">
            <div v-if="row.approveRemark">
              <el-popover
                v-if="row.approveRemark && row.approveRemark.length > 12"
                placement="top-start"
                width="300"
                trigger="hover"
                :content="row.approveRemark"
              >
                <div slot="reference" class="remark">
                  {{ row.approveRemark }}
                </div>
              </el-popover>
              <div v-else>{{ row.approveRemark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: '/depositWithdraw/selectList?type=01',
      timeDate: [],
      form: {
        startDate: '',
        endDate: '',
        status: '',
        sortType: '00',
      },
    }
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate)
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    reset() {
      this.timeDate = []
    },
  },
}
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>